<template><div><h1 id="jobs-ausfuhren-als-benutzer" tabindex="-1"><a class="header-anchor" href="#jobs-ausfuhren-als-benutzer"><span>Jobs ausführen als Benutzer</span></a></h1>
<p>Jobs ausführen als Benutzer — Führt Jobs als einen anderen Benutzer durch</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle können Programme (Jobs) definiert werden, die als einen anderen Benutzer z.B. als svw (Systemverwalter) ausgeführt werden. Insbesondere regelmässige Jobs die nicht einem bestimmten Benutzer gehören resp. zugeordnet sind wie z.B. Buchungen einlesen, EGA Zahlungen einlesen/verarbeiten, FTML-Import, etc.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Systemtabellen → Korrespondenztypen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Programm</dt>
<dd>Eingabe des Programms des entsprechenden Jobs</dd>
<dt>Programmname</dt>
<dd>Anzeige des Namen des Programms (Read-Only)</dd>
<dt>Benutzer</dt>
<dd>Auswahl eines Benutzers aus der Benutzertabelle</dd>
</dl>
</div></template>


